import { render, staticRenderFns } from "./seckillDetail.vue?vue&type=template&id=75718690&scoped=true&"
import script from "./seckillDetail.ts?vue&type=script&lang=ts&"
export * from "./seckillDetail.ts?vue&type=script&lang=ts&"
import style0 from "./seckillDetail.vue?vue&type=style&index=0&id=75718690&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75718690",
  null
  
)

export default component.exports